import React, { Component } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { SuccessButton } from 'components/connectedForm/Button';
import styled from 'styled-components';
import ComponentMutation from '../utils/ComponentMutation';
import SystemCompanySetupComplete from 'graphql/mutations/system/SystemCompanySetupComplete.graphql';
import getClientMutationId from '../utils/getClientMutationId';
import componentQuery from '../utils/componentQuery';
import CurrentUserQuery from 'graphql/queries/system/CurrentUserQuery.graphql';
import SVGIcon from '../components/SVGIcons';
import theme from 'styles/themes/default/defaultTheme';
import { getIcon } from '../components/MenuOptions/MenuOptionIcons';

const Title = styled.p`
  font-size: 28px;
  color: ${theme.colors.notificationDefault};
  margin-bottom: 20px;
`;

const Container = styled.div`
  text-align: center;
  margin-top: 150px;
`;

const SVGContainer = styled.div`
  margin-bottom: 20px;
`;

const BtnContainer = styled.div`
  width: 200px;
  margin: 0 auto;
`;

const Text = styled.p`
  font-size: 22px;
  color: #9e9e9e;
`;

class SetupComplete extends Component {
  constructor(props) {
    super(props);
    this.finish = this.finish.bind(this);

    this.state = {
      companyChecked: false,
    };
  }

  componentWillMount() {
    componentQuery(CurrentUserQuery, {}, true, 'network-only').then(({ response: data }) => {
      let companyChecked = true;
      if (data.currentUser.currentCompany && data.currentUser.currentCompany.setUpComplete) {
        companyChecked = false;
        window.location.replace('/');
      }

      this.setState({
        companyChecked,
      });
    });
  }

  finish() {
    ComponentMutation(
      SystemCompanySetupComplete,
      {
        clientMutationId: getClientMutationId(),
      },
      true
    ).then(() => {
      window.location.replace('/');
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.state.companyChecked ? (
          <Container>
            <Title>
              Company Setup Complete
              <i style={{ fontSize: '28px', color: theme.colors.hintIcon, paddingLeft: '5px' }} className="icon">
                check_circle
              </i>
            </Title>
            <SVGContainer>
              <SVGIcon icon={getIcon('Company')} height={200} width={200} fillColor="#DDD" />
            </SVGContainer>
            <Text>{this.props.company.name} is ready to go!</Text>
            <BtnContainer>
              <SuccessButton onClick={this.finish} large={true}>
                Finish
              </SuccessButton>
            </BtnContainer>
          </Container>
        ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    company: state.app.company,
  };
}

export default compose(connect(mapStateToProps))(SetupComplete);
